// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3pYb3","Label":"BuildControl_Label__7ChAK","Less":"BuildControl_Less__3Qy7R","More":"BuildControl_More__3ibYu"};